var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBluetoothConnectedCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "40px",
    viewBox: "0 -960 960 960",
    width: "40px",
    fill: "#405CB0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M445.74-87.18v-309.31L256.67-207.18 207.85-256l224-224-224-224 48.82-48.82 189.07 189.15v-309.15h34.93L701.49-652l-172 172 172 172L480.67-87.18h-34.93Zm69.85-476.49L603.85-652l-88.26-86.49v174.82Zm0 342L603.85-308l-88.26-88.49v174.82ZM197.07-426.41q-22.76 0-38.52-15.54-15.76-15.55-15.76-38.03t15.74-38.72q15.74-16.23 38.5-16.23 22.76 0 38.4 16.22 15.64 16.21 15.64 38.69 0 22.48-15.62 38.05-15.62 15.56-38.38 15.56Zm565.9 0q-22.76 0-38.4-15.54-15.64-15.55-15.64-38.03t15.62-38.72q15.62-16.23 38.38-16.23 22.76 0 38.52 16.22 15.76 16.21 15.76 38.69 0 22.48-15.74 38.05-15.74 15.56-38.5 15.56Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluetoothConnectedCorrect);
export default __webpack_public_path__ + "static/media/bluetooth-connected-correct.cd1eb8439481b0ce9e90791b765d20c9.svg";
export { ForwardRef as ReactComponent };